// ----------------------------------------------------------------------

export const mockImgAvatar = () => `/static/avatar_default.jpg`;
